import React from 'react';
import MonoHtmlView from './CommissionHtml';
import MonoReactView from './Commission';
const CommissionMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(MonoHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(MonoReactView, props);
};
CommissionMonoView.displayName = 'CommissionMonoView';
export default CommissionMonoView;
